import React, {Component} from 'react';

// Components
import Feature from '../../components/Feature/Feature';

class StandardFeatures extends Component {
    render () {
        return (
            
            <div className={ `standard-features ${this.props.classes}` } >
                <h4 className="heading">{this.props.title}</h4>

                <div className="row">
                	<div className="col-12 col-md-6 col-xl-4  standard-features__col">
                		<Feature icon="phone" title="Beautiful Responsive Themes" text={
                			<div>
                				Serve an optimised version of the theme to your visitors on tablet and mobile devices - it all works out the box.
                			</div>
                		} />
                	</div>
                	<div className="col-12 col-md-6 col-xl-4  standard-features__col">
                		<Feature icon="global" title="Translation & Multilanguage Ready" text={
                			<div>
                				All of our themes are Internationalized (I18n). You can easily translate them to your own language.
                			</div>
                		} />
                	</div>
                	<div className="col-12 col-md-6 col-xl-4  standard-features__col">
                		<Feature icon="browser" title="Cross-browser Compatibility" text={
                			<div>
                				Cross browser compatibility and W3C validation of our themes are crucial in the successful running of the website.
                			</div>
                		} />
                	</div>
                	<div className="col-12 col-md-6 col-xl-4  standard-features__col">
                		<Feature icon="compass" title="Professional Design & Code" text={
                			<div>
                				Our team has made effort to bring you professional and good looking themes.
                			</div>
                		} />
                	</div>
                	<div className="col-12 col-md-6 col-xl-4  standard-features__col">
                		<Feature icon="refresh-2" title="Regular updates & new layouts" text={
                			<div>
                				We provide you with expert support and unlimited updates to purchased themes.
                			</div>
                		} />
                	</div>
                	<div className="col-12 col-md-6 col-xl-4  standard-features__col">
                		<Feature icon="help1" title="Detailed documentation" text={
                			<div>
                				To learn how to use our template is very simple with our detailed documentation. 
                			</div>
                		} />
                	</div>
                	<div className="col-12 col-md-6 col-xl-4  standard-features__col">
                		<Feature icon="music" title="Built-in Music Player" text={
                			<div>
                				All of our themes have a built-in powerful music player.
                			</div>
                		} />
                	</div>
                	<div className="col-12 col-md-6 col-xl-4  standard-features__col">
                		<Feature icon="drop" title="Theme Customizer" text={
                			<div>
                				Use our helpful Customizer theme options to effortlessly set up, customize and launch your website.
                			</div>
                		} />
                	</div>
                	<div className="col-12 col-md-6 col-xl-4  standard-features__col">
                		<Feature icon="upload" title="Simple Installation" text={
                			<div>
                				Your themes will up and running in no time thanks to our quick and easy installation process. Just 1 Click, for real!. 
                			</div>
                		} />
                	</div>
                </div>
            </div>

        );
    }
}

export default StandardFeatures;


// WEBPACK FOOTER //
// ./src/containers/StandardFeatures/StandardFeatures.js